<template>
    <div class="p-0 z-20">
        <nav :class="isOpen ? 'bg-blue-600 h-screen z-10' : 'bg-blue-500'">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-3">
                <div class="flex items-center justify-between h-auto">
                    <div class="flex items-center w-full justify-center lg:justify-between">
                        <div class="flex-shrink-0 ml-10 md:ml-16 lg:ml-0">
                            <slot name="logo" />
                        </div>
                        <div class="hidden lg:block sm:ml-6">
                            <div class="flex items-center space-x-6">
                                <slot name="navigation" />
                                <div class="ml-10 relative">
                                    <div>
                                        <button
                                            class="flex items-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white flex-shrink-0 space-x-1 bg-blue-300 px-3 py-2 rounded uppercase font-semibold text-blue-500"
                                            id="user-menu"
                                            aria-haspopup="true"
                                            @click="countryDropdownIsOpen = !countryDropdownIsOpen"
                                        >
                                            <slot name="currentCountryDesktop"/>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor" class="w-4 h-4">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M19 9l-7 7-7-7"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <transition
                                        enter-active-class="transition ease-out duration-100"
                                        enter-from-class="transform opacity-0 scale-95"
                                        enter-to-class="transform opacity-100 scale-100"
                                        leave-active-class="transition ease-in duration-75"
                                        leave-from-class="transform opacity-100 scale-100"
                                        leave-to-class="transform opacity-0 scale-95"
                                    >
                                    <div
                                        class="origin-top-right absolute right-0 mt-2 z-20"
                                        role="menu"
                                        aria-orientation="vertical"
                                        aria-labelledby="user-menu"
                                        :class="countryDropdownIsOpen ? 'block' : 'hidden'"
                                    >
                                        <slot name="countrySwitcherDesktop"/>
                                    </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="-mr-2 flex lg:hidden">
                        <button
                            type="button"
                            class="inline-flex items-center justify-center p-2 rounded-md text-blue-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                            aria-controls="mobile-menu"
                            aria-expanded="false"
                            @click="isOpen = !isOpen"
                        >
                            <span class="sr-only">Open het menu</span>
                            <svg class="feather feather-menu h-8 w-8 fill-current focus:ring-2 focus:ring-blue-400 focus:outline-none" :class="isOpen ? 'hidden' : 'block'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                            <svg class="feather feather-x h-8 w-8 fill-current focus:outline-none focus:ring-2 focus:ring-blue-400" :class="isOpen ? 'block' : 'hidden'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </button>
                    </div>
                </div>
            </div>
            <div
                class="lg:hidden"
                id="mobile-menu"
                :class="isOpen ? 'block' : 'hidden'"
            >
                <div class="py-10 space-y-10">
                    <slot name="navigation" />
                    <div class="flex justify-center">
                        <div class="space-y-0 mx-auto inline-grid grid-cols-2 gap-5">
                        <slot name="countrySwitcherMobile" />
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>

export default {
    name: "NavigationBar",
    data: () => ({
        isOpen: false,
        countryDropdownIsOpen: false,
    }),
    watch: {
        isOpen: function() {
            document  .body.style.overflow = this.isOpen ? "hidden" : "";
        },
    },
};
</script>

<style scoped></style>
